import { isSodimacStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import constants from '../../../config/constants';
import Button from '../../ui/Button/Button';
import { Modal } from '../../ui/Modal/Modal';
import CreateListButton from '../CreateList/CreateList';
import CreateListForm from '../CreateListForm/CreateListForm';
import List from '../List/List';
import styles from '../MyLists.style';

const MyListsModal = ({
  appCtx,
  onSaveLists,
  createList,
  toggleState,
  myLists,
  onListChange,
  validateList,
  error,
  loading,
  labels,
  formState,
  isSaveButtonEnabled,
}) => {
  const { deviceType, store } = appCtx;

  const isTocom = store === constants.STORES.to_com;
  const isSodimacSA = isSodimacStandalone(store);
  const [modalTitle, setModalTitle] = useState('');
  const paddingModal = deviceType === 'desktop' ? '28px 27px 24px 27px' : '24px 16px 16px 16px';

  const handleCloseModal = () => {
    toggleState.setVisible(!toggleState.visible);
    formState.setVisible(false);
  };

  useEffect(() => {
    const newTitle = formState.visible ? labels.createNewList : labels.addToList;
    setModalTitle(newTitle);
  }, [formState.visible]);

  const modalContent = () => {
    return (
      <div className="my-lists-modal-container">
        <div className="my-lists-modal-header">
          <i className={`csicon-my-list ${isSodimacSA ? 'sodimac' : ''}`} />
          <span>{modalTitle}</span>
          {!formState.visible && deviceType === 'desktop' && <p>{labels.modalSubtitle}</p>}
        </div>
        {formState.visible ? (
          <CreateListForm
            validateList={validateList}
            onSubmit={createList}
            error={error}
            loading={loading}
            labels={labels}
          />
        ) : (
          <>
            <List title={labels.myLists} onListChange={onListChange} items={myLists} deviceType={deviceType} />
            <CreateListButton
              label={labels.createNewList}
              showForm={formState.setVisible}
              onClickCreateList={formState.setIsClickedMetric}
            />
            <div className={`my-lists-button ${isTocom ? 'to_com' : ''}`}>
              <div className="box-button">
                {isTocom ? (
                  <button
                    type="button"
                    onClick={onSaveLists}
                    disabled={!isSaveButtonEnabled}
                    id="myListSaveButton"
                    className="tocom-save-button"
                  >
                    {labels.save}
                  </button>
                ) : (
                  <Button
                    letterSpace="regular"
                    type="mkp-secondary"
                    onClick={onSaveLists}
                    disabled={!isSaveButtonEnabled}
                    id="myListSaveButton"
                  >
                    {labels.save}
                  </Button>
                )}
              </div>
            </div>
          </>
        )}
        <style jsx>{styles}</style>
      </div>
    );
  };

  return (
    <Modal
      showCloseButton
      content={modalContent}
      options={{
        width: 500,
        height: 'auto',
        maxHeight: 515,
        padding: paddingModal,
        borderRadius: '5px',
      }}
      toggleState={{
        visible: toggleState.visible,
        setVisible: handleCloseModal,
      }}
      withPadding={false}
      className="bottom"
      customClassBody="auto"
      fullWidth={deviceType !== 'desktop'}
      deviceType={deviceType}
    />
  );
};

MyListsModal.propTypes = {
  appCtx: PropTypes.object.isRequired,
  onSaveLists: PropTypes.func.isRequired,
  createList: PropTypes.func.isRequired,
  onListChange: PropTypes.func.isRequired,
  validateList: PropTypes.func.isRequired,
  myLists: PropTypes.array.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isSaveButtonEnabled: PropTypes.bool,
  toggleState: PropTypes.objectOf({
    visible: PropTypes.bool.isRequired,
    setVisible: PropTypes.func.isRequired,
  }).isRequired,
  formState: PropTypes.objectOf({
    visible: PropTypes.bool.isRequired,
    setVisible: PropTypes.func.isRequired,
    setIsCreateListClicked: PropTypes.func.isRequired,
  }).isRequired,
  labels: PropTypes.objectOf({
    save: PropTypes.string,
    myLists: PropTypes.string,
    inputNewListName: PropTypes.string,
    addToAlist: PropTypes.string,
    createNewList: PropTypes.string,
    addToList: PropTypes.string,
  }),
};
MyListsModal.defaultProps = {
  error: '',
  loading: false,
  labels: {},
  isSaveButtonEnabled: true,
};
export default MyListsModal;
